export const number1 = 8988844411
export const number2 = 8988844422
export const mainWhatsappNumber = 8988844422
